















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "../../plugins/http";

@Component
export default class Index extends Vue {
  compressCode: string = "";

  skuCode: string = "";
  replacedCode: string = "";

  tableData: any[] = [];
  pageNo: number = 1;
  total: number = 1;
  size: number = 100;
  loading: boolean = false;
  visible: boolean = false;
  search: string = "";

  created() {
    this.getList();
  }

  handlePageChange(val) {
    this.pageNo = val;
    this.getList();
  }
  getList() {
    this.loading = true;
    Axios.getSecret(`/api/skuCodeReplace/page`, {
      pageNo: this.pageNo,
      search: this.search,
    }).then(
      ({
        data: {
          data: { records, total, size },
          status,
          msg,
        },
      }) => {
        this.loading = false;
        if (status === 200) {
          this.tableData = records;
          this.total = total;
          this.size = size;
        } else {
          this.$message(msg);
        }
      }
    );
  }
  addRule() {
    this.visible = true;
    this.skuCode = "";
    this.replacedCode = "";
  }
  modify(row) {
    this.$set(row, "isEdit", true);
  }
  submitRule(row) {
    // 检查是否有多个+号
    if (!this.replacedCode.split("+").every((item) => item)) {
      this.$message.error("保存失败，请检查编码是否有误");
      return;
    }
    let postData: any = {};
    if (!row) {
      postData.skuCode = this.skuCode;
      postData.replacedCode = this.replacedCode;
      this.submitData(postData);
    } else {
      postData.id = row.id;
      postData.skuCode = row.skuCode;
      postData.replacedCode = row.replacedCode;
      this.$confirm("确认修改吗? ", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "accountConfirm",
      }).then(() => {
        this.submitData(postData);
      });
      this.$set(row, "isEdit", false);
    }
  }

  submitData(postData) {
    Axios.postByJson("/api/skuCodeReplace/save", postData)
      .then((res) => {
        if (res.data.status === 200) {
          this.$message({
            type: "success",
            message: `保存成功`,
          });
          this.visible = false;
          this.getList();
        } else {
          this.$message(res.data.msg);
        }
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消",
        });
      });
  }

  deleteRule(id) {
    this.$confirm("确认删除吗? 删除后替换规则将失效", "", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      type: "warning",
      customClass: "accountConfirm",
    }).then(() => {
      Axios.postByJson("/api/skuCodeReplace/delete", { id })
        .then((res) => {
          if (res.data.status === 200) {
            this.$message({
              type: "success",
              message: `删除成功`,
            });
            this.getList();
          } else {
            this.$message(res.data.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    });
  }
  copyData(row) {
    let input: any = document.getElementById("copy");
    let text = row.replacedCode;
    input.value = text; // 修改文本框的内容
    input.select(); // 选中文本
    document.execCommand("copy"); // 执行浏览器复制命令
    this.$message("已复制");
  }
}
